import { css } from '@emotion/react';
import { ReactElement } from 'react';

import { styled } from '../../../../styled';
import { Theme } from '../../../../theme/interface/detailed';

type Interface = {
	text: string;
	className: string;
	required: boolean;
	hasError: boolean;
};

export const Label = styled(
	({ text, className, required }: Interface): ReactElement => (
		<div className={className}>
			<span>{text}</span>
			{required && <div>*</div>}
		</div>
	)
)(
	({ theme }: { theme: Theme }) => theme.allSettings.fields.label,
	({ theme, hasError }: { theme: Theme; hasError: boolean }) => css`
		${hasError && `color: ${theme.allSettings.fields.common.errorColor};`}
		display: flex;

		& > span {
			display: inline-block;
			font-family: ${theme.allSettings.fields.label.labelFontFamily};
			font-weight: bold;
			word-break: break-word;
		}

		& > div {
			color: transparent;
			font-family: emoji;
			font-size: 10px;
			height: 9px;
			margin: -2px 0 0 -1px;
			text-shadow: 0 0 0 #ed3945;
		}
	`
);
